/**
 * errorReporting.ts
 *
 * Melhor esforço: envia erros pegos pelos error boundaries (app/error.tsx,
 * secure/error.tsx) para a API, para dar visibilidade a crashes que hoje só
 * aparecem no console do aparelho do usuário — no APK isso é praticamente
 * invisível para nós. Nunca lança; uma falha ao reportar não pode virar um
 * novo erro dentro do próprio error boundary.
 */

import { http } from "@/lib/http"
import { isNativeApp } from "@/lib/platform"

export function reportClientError(error: Error & { digest?: string }, path?: string): void {
  void http
    .post("/api/diagnostics/client-error", {
      message: error.message,
      stack: error.stack ?? null,
      digest: error.digest ?? null,
      path: path ?? (typeof window !== "undefined" ? window.location.pathname : null),
      platform: isNativeApp() ? "native" : "web",
    })
    .catch(() => {
      // Sem sessão válida, sem rede etc. — o console.error já cobre o caso local.
    })
}
